import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight} from "react-icons/im";
import {MdControlPoint} from "react-icons/md";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Akhil JP </span>
            from <span className="purple"> Trivandrum, India.</span>
            <br />I am a Software Developer and a content creator
            <br />
            <br />
            In addition to coding, there are other pastimes that I am passionate about.
          </p>
          <ul>
            <li className="about-activity">
              <MdControlPoint /> Singing
            </li>
            <li className="about-activity">
              <MdControlPoint /> Content creation
            </li>
            <li className="about-activity">
              <MdControlPoint /> Traveling and exploring new places
            </li>
            <li className="about-activity">
              <MdControlPoint /> Playing badminton
            </li>
            <li className="about-activity">
              <MdControlPoint /> Exploring New foods
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Don't wait for the perfect moment, take the moment and make it perfect.!"{" "}
          </p>
          <footer className="blockquote-footer">Akhil</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
